import { ReactElement } from "react";
import { MyAccountReadingHistoryPageEmptyState } from "@routes/MyAccount/utils/constants";

/**
 * MyAccountReadingHistoryEmptyState is a component displayed in my account reading history when the user has not read any articles.
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3611-26543&t=1IQZnRIEwkg358qY-4
 */
const MyAccountReadingHistoryEmptyState = (): ReactElement => {
  return (
    <div
      data-testid="my-account-reading-history-page-empty-state-component"
      className="my-15"
    >
      <img
        className="mx-auto mb-8"
        src={MyAccountReadingHistoryPageEmptyState.src}
        alt="Recent read"
        width={180}
        height={170}
      />

      <p className="mb-0 text-center font-poppins font-semibold text-gray-850">
        {MyAccountReadingHistoryPageEmptyState.description}
      </p>

      <p className="mb-0 text-center font-poppins text-gray-850">
        {MyAccountReadingHistoryPageEmptyState.descriptionLine2}
      </p>
    </div>
  );
};

export default MyAccountReadingHistoryEmptyState;
